/** Nomes normativos (backend session_cookies.py) — manter alinhados ao P1 Login. */
export const SESSION_COOKIE_NAME = '__Host-granjasmart_session'
export const CSRF_COOKIE_NAME = '__Host-granjasmart_csrf'
export const CSRF_HEADER_NAME = 'X-CSRF-Token'

const LEGACY_TOKEN_KEY = 'token'

const UNSAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE'])

export function isUnsafeHttpMethod(method?: string): boolean {
  return UNSAFE_METHODS.has((method ?? 'GET').toUpperCase())
}

/** Remove JWT legado do localStorage sem ler o valor (rollout P1). */
export function clearLegacyTokenStorage(): void {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(LEGACY_TOKEN_KEY)
}

/** Lê o token CSRF legível do cookie __Host-granjasmart_csrf. */
export function readCsrfTokenFromDocument(): string | null {
  if (typeof document === 'undefined') return null
  const prefix = `${CSRF_COOKIE_NAME}=`
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim()
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length))
    }
  }
  return null
}
